import React from 'react';

import { Cell, Container, Grid } from '../../layout';
import Divide from '../divide/Divide';

import footerLogo from '../../../assets/images/footer-logo.png';

const Footer = () => (
  <Container>
    <Divide isXLarge={true} isLight={true} />

    <footer className="c-footer">
      <Grid>
        <Cell size={{ desktop: '6', tablet: '6', phone: '6' }}>
          <p>Follow us here to find out more and have your say</p>
          <ul className="c-footer__social-list">
            <li>
              <a href="https://twitter.com/newcastlecc" rel="noopener noreferrer" target="_blank">
                <i className="fab fa-twitter" />
              </a>
            </li>
            <li>
              <a href="http://www.facebook.com/newcastlecitycouncil" rel="noopener noreferrer">
                <i className="fab fa-facebook-f" />
              </a>
            </li>
          </ul>
          <div className="footer-email-info-container">
            <p>If you have questions about the People’s Budget, please email us here: <a href="mailto:letstalk@newcastle.gov.uk">letstalk@newcastle.gov.uk</a></p>
          </div>
          <small>
            This interactive tool is not designed to give you a full representation of
            local government finance, but an insight into the difficult decisions
            councillers must make when setting a legal budget. All feedback and
            suggestions that are submitted will be considered before we set our budget
            in March next year.
          </small>
        </Cell>
        <Cell size={{ desktop: '6', tablet: '6', phone: '6' }}>
          <div className="u-text-right u-text-center--mobile">
            <img className="c-footer__logo" src={footerLogo} alt="Newcastle City Council Logo" width="175" />
          </div>
        </Cell>
        <Cell size={{ desktop: '6', tablet: '6', phone: '6' }}>
          <ul className="c-footer__link-list">
            <li>
              <a href="https://www.letstalknewcastle.co.uk/page/terms-and-conditions" className="c-footer__link-list-link" target="_blank" rel="noopener noreferrer">
                Terms and Conditions
              </a>
            </li>
            <li>
              <a href="https://www.letstalknewcastle.co.uk/page/accessibility" className="c-footer__link-list-link" target="_blank" rel="noopener noreferrer">
                Accessibility
              </a>
            </li>
            <li>
              <a href="https://www.letstalknewcastle.co.uk/page/privacy-policy" className="c-footer__link-list-link" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
          </ul>
        </Cell>
        <Cell size={{ desktop: '6', tablet: '6', phone: '6' }}>
          <div className="u-text-right u-text-center--mobile">
            <p>&copy; Newcastle City Council</p>
          </div>
        </Cell>
      </Grid>
    </footer>
  </Container>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/footer/Footer.jsx